import { ReportTableAction } from '@/modules/learner/hooks/useReportTableActions/actions';
import { UpdateUserInput } from '@/types/schema';

export enum LearnerProfileActionTypes {
  ShareLearnerProfile = 'SHARE_LEARNER_PROFILE',
  SetInViewModal = 'SET_IN_VIEW_MODAL',
  HideInViewModal = 'HIDE_IN_VIEW_MODAL',
  UpdateProfile = 'UPDATE_PROFILE',
  Masquerade = 'MASQUERADE',
  Deactivate = 'DEACTIVATE',
  Reactivate = 'REACTIVATE',
  RemoveStaff = 'REMOVE_STAFF',
  Assignment = 'ASSIGNMENT',
  ResetPassword = 'RESET_PASSWORD',
  EditProfile = 'EDIT_PROFILE',
  GoToTeamProfile = 'GO_TO_TEAM_PROFILE',
  PublicAPICredentials = 'PUBLIC_API_CREDENTIALS',
}

export type LearnerProfileModalType =
  | 'Profile'
  | 'Masquerade'
  | 'Deactivate'
  | 'Reactivate'
  | 'Assignment'
  | 'EditSelfProfile'
  | 'PublicAPICredentials'
  | 'EditEmployeeProfile'
  | 'ResetPassword';

export interface UpdateProfile {
  type: LearnerProfileActionTypes.UpdateProfile;
  payload: {
    updatedValues: UpdateUserInput;
    snackbarSuccessMessage?: string;
    snackbarStartIcon?: React.ReactNode;
  };
}

export interface RemoveStaff {
  type: LearnerProfileActionTypes.RemoveStaff;
  payload: {
    learnerId: string;
    learnerName: string;
  };
}

export interface SetInViewModal {
  type: LearnerProfileActionTypes.SetInViewModal;
  payload: {
    modalType: LearnerProfileModalType;
  };
}

export interface HideInViewModal {
  type: LearnerProfileActionTypes.HideInViewModal;
}

export interface ReactivateLearnerAction {
  type: LearnerProfileActionTypes.Reactivate;
}

export interface ShareLearnerProfileAction {
  type: LearnerProfileActionTypes.ShareLearnerProfile;
}

export interface AssignmentAction {
  type: LearnerProfileActionTypes.Assignment;
  payload: {
    userId: string;
    assignerId: string;
    items: {
      selectedContentIds: string[];
      selectedCollectionIds: string[];
      selectedEventsIds: string[];
    };
    dueDate?: string;
    onSuccess: (id: string) => void;
    onError: () => void;
  };
}

export type LearnerProfileAction =
  | SetInViewModal
  | ShareLearnerProfileAction
  | HideInViewModal
  | UpdateProfile
  | RemoveStaff
  | AssignmentAction;

export type OnLearnerProfileAction = (
  action: LearnerProfileAction | ReportTableAction,
) => Promise<any>;
